import { render, staticRenderFns } from "./RouteListItemMenu.vue?vue&type=template&id=5213315c&scoped=true"
import script from "./RouteListItemMenu.vue?vue&type=script&lang=js"
export * from "./RouteListItemMenu.vue?vue&type=script&lang=js"
import style0 from "./RouteListItemMenu.vue?vue&type=style&index=0&id=5213315c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5213315c",
  null
  
)

export default component.exports